/* eslint-disable default-param-last, @typescript-eslint/default-param-last */
import { OPEN_MODAL, CLOSE_MODAL, ACTIVATE_CAARL_TOUR, DEACTIVATE_CAARL_TOUR } from '../actions/index'

type UiInitialState = {
  modalsQueue: {
    modalName: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    modalProps: any,
  }[]
  caarlTourActive: boolean
}

const initialState: UiInitialState = {
  modalsQueue: [],
  caarlTourActive: false,
}

const stepper = (state = initialState, action: ReduxAction) => {
  switch (action.type) {
    case OPEN_MODAL:
      return {
        ...state,
        modalsQueue: [
          ...state.modalsQueue,
          {
            modalName: action.modalName,
            modalProps: action.modalProps,
          },
        ],
      }
    case CLOSE_MODAL:
      return {
        ...state,
        modalsQueue: state.modalsQueue.slice(1),
      }
    case ACTIVATE_CAARL_TOUR:
      return {
        ...state,
        caarlTourActive: true,
      }
    case DEACTIVATE_CAARL_TOUR:
      return {
        ...state,
        caarlTourActive: false,
      }
    default:
      return state
  }
}

export default stepper
